import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';

import BasicModal       from '@partials/basic-modal';

// -------------------------------------------------------


class ExLoginUrl extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      modal: false,
      exlogin_url: null,
      login_password: null,
    };
  }
  // -------------------------------------------------------
  
  showToggle(flg) {
    let detail = this.props.detail;
    
    Utils.request.bind(this)('/api/project/influencer/get_exlogin_url', { project_id: detail.project_id, insta_user_id: detail.insta_user_id },
      function(res){
        this.setState({ modal: flg, exlogin_url: res.body.url, login_password: res.body.login_password });
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  closeToggle() {
    this.setState({ modal: false });
  }
  // -------------------------------------------------------
  
  createExLoginUrl() {
    let detail = this.props.detail;
    
    if( this.password.value == '' ){
      alert('セキュリティを担保するために、パスワードの入力が必須になります。');
      return;
    }
    
    let chk = confirm('エントリー代行用のURLを発行しますか？');
    if( chk == false ) return;
    
    Utils.request.bind(this)('/api/project/influencer/create_exlogin_url', { project_id: detail.project_id, insta_user_id: detail.insta_user_id, mode: 'create', password: this.password.value },
      function(res){
        this.setState({ exlogin_url: res.body.url, login_password: this.password.value });
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  deleteExLoginUrl() {
    let detail = this.props.detail;
    
    let chk = confirm('エントリー代行用のURLを利用不可能な状態にしてもよろしいですか？');
    if( chk == false ) return;
    
    Utils.request.bind(this)('/api/project/influencer/create_exlogin_url', { project_id: detail.project_id, insta_user_id: detail.insta_user_id, mode: 'delete' },
      function(res){
        this.setState({ exlogin_url: null });
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  render() {
    let detail = this.props.detail;
    
    let exlogin_url = 'https://casting.moribus.jp/login/ex/'+ this.state.exlogin_url;
    
    // アクション
    return (
      <div>
        <li className="on" onClick={this.showToggle.bind(this, true)}>
          {this.props.button}
        </li>
        
        {(this.state.modal == true && this.state.exlogin_url == null) &&
          <BasicModal
            modal_active={true}
            title = "エントリー代行用のURL発行"
            sub_title = "セキュリティのため、ログインするためのパスワードが必要になります。"
            width = {600}
            contents = {
              <div className="exlogin-modal">
                <h6>パスワードを入力</h6>
                <input className="text" type="text" ref={(input) => { this.password = input }} placeholder="パスワード" />
                
                <div className="button" onClick={this.createExLoginUrl.bind(this)}>作成</div>
              </div>
            }
            contents_height = {130}
            close_ev={this.closeToggle.bind(this)}
            buttons = {
              [{ id: 'yes', name: '閉じる', event: this.showToggle.bind(this, false)}]
            }
          />
        }
        
        {(this.state.modal == true && this.state.exlogin_url != null) &&
          <BasicModal
            modal_active={true}
            title = "エントリー代行用のURL発行"
            width = {600}
            contents = {
              <div className="exlogin-modal">
                <h6>エントリー代行URL</h6>
                <a href={exlogin_url} target="_blank">{exlogin_url}</a>
                
                <h6>パスワード</h6>
                <p>{this.state.login_password}</p>
                
                <div className="button delete-btn" onClick={this.deleteExLoginUrl.bind(this)}>利用不可能な状態にする</div>
              </div>
            }
            contents_height = {170}
            close_ev={this.closeToggle.bind(this)}
            buttons = {
              [{ id: 'yes', name: '閉じる', event: this.showToggle.bind(this, false)}]
            }
          />
        }
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default ExLoginUrl;